
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Dailyofficecabserviceinpune() {



    const cardData =
    {
        keyword: 'Daily Office Cab Service in Pune',
        heading: 'Platinum24 Cabs: Daily Office Cab Service in Pune',
        headingDescription: ' Platinum24 Cabs provides reliable Daily Office Cab Service in Pune, ensuring safe, punctual, and comfortable commutes for professionals across the city. Our fleet of hatchbacks, sedans, SUVs, and luxury cars is well-maintained to offer smooth rides with air-conditioned comfort. With trained chauffeurs, flexible scheduling, and transparent fares, we make daily office travel stress-free and cost-effective. Whether you’re commuting to Hinjewadi IT Park, Magarpatta, Kharadi, or Baner, Platinum24 Cabs guarantees on-time pickups, 24/7 availability, and dependable office cab solutions for individuals and corporate teams.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


       "services": [
    {
      "name": "Daily Office Cab Pune",
      "description": "Experience hassle-free daily commuting with our Daily Office Cab service in Pune. Designed for working professionals, this service offers timely pickups and drop-offs from your home to workplace and back. Our well-maintained fleet ensures comfort during your daily journey, and professional drivers guarantee punctuality and safety throughout the ride. Enjoy flexible subscription plans tailored to fit your work schedule and budget, making your daily commute stress-free and reliable."
    },
    {
      "name": "Pune Office Taxi Service",
      "description": "Our Pune Office Taxi Service caters specifically to the corporate community, offering efficient and affordable transportation for employees. Whether you need regular daily rides or occasional office transfers, our service ensures convenience, comfort, and safety. With GPS tracking and real-time updates, you stay informed about your ride, reducing waiting times and enhancing productivity."
    },
    {
      "name": "Office Cab Booking Pune",
      "description": "Book your Office Cab in Pune effortlessly with our easy-to-use online platform or mobile app. Choose your preferred vehicle type, schedule pickups, and manage recurring rides with ease. Our transparent pricing and seamless booking process allow you to plan your daily office commute in advance, eliminating last-minute hassles."
    },
    {
      "name": "Daily Work Taxi Pune",
      "description": "Our Daily Work Taxi service in Pune is designed to provide consistent and affordable transport solutions for your everyday office travel needs. Enjoy the convenience of door-to-door service, clean and comfortable vehicles, and experienced drivers who prioritize your safety and timely arrival."
    },
    {
      "name": "Corporate Daily Taxi Pune",
      "description": "Specialized Corporate Daily Taxi service in Pune caters to businesses seeking reliable employee transportation. We offer customized packages, bulk booking discounts, and priority support to ensure smooth office transport operations. Our professional drivers adhere to corporate protocols, providing a professional and courteous experience."
    },
    {
      "name": "Affordable Office Cab Pune",
      "description": "Get affordable and budget-friendly office cab services in Pune without compromising on quality. Our cost-effective plans are ideal for individuals and companies looking to optimize daily transportation expenses while enjoying comfortable and punctual rides."
    },
    {
      "name": "Office Taxi with Driver Pune",
      "description": "Travel safely and comfortably with our Office Taxi service in Pune that includes professional drivers well-versed with city traffic patterns and corporate schedules. Our drivers are background-checked and trained to offer courteous, punctual, and hassle-free commutes."
    },
    {
      "name": "Pune Office Cab Packages",
      "description": "Choose from various Pune Office Cab Packages tailored for daily commuters, corporate clients, and groups. Packages include monthly subscriptions, fixed-route plans, and flexible timings, all designed to provide maximum convenience and savings for regular office travel."
    },
    {
      "name": "Pune Daily Commute Taxi",
      "description": "Our Pune Daily Commute Taxi service ensures you reach your workplace on time every day. Offering door-to-door pickups, reliable vehicles, and professional drivers, we make your daily travel stress-free and comfortable."
    },
    {
      "name": "Office Cab Service Near Me Pune",
      "description": "Find reliable and nearby office cab services in Pune with our extensive network of local taxis. Enjoy quick bookings, prompt pickups, and consistent service quality wherever you are located in the city."
    },
    {
      "name": "Pune Daily Taxi Deals",
      "description": "Avail exclusive Pune Daily Taxi Deals that offer discounts on monthly and weekly office cab subscriptions. These deals provide excellent value for frequent commuters, helping reduce transportation costs while ensuring dependable service."
    },
    {
      "name": "Pune Office Transport Cab",
      "description": "Our Pune Office Transport Cab service offers organized, scheduled rides catering to large corporate groups and businesses. From single pickups to fleet management, we ensure timely and coordinated office commutes for your workforce."
    },
    {
      "name": "Daily Office Cab Rental Pune",
      "description": "Rent a Daily Office Cab in Pune for your daily commute with flexible rental plans. Whether you need a cab for a few days or an entire month, our rental service offers convenience, affordability, and professional service tailored to your work schedule."
    },
    {
      "name": "Pune Office Shuttle Cab",
      "description": "Opt for our Pune Office Shuttle Cab service to enjoy shared rides with fellow commuters on fixed routes. This eco-friendly and economical solution helps reduce traffic congestion while offering convenient office transportation."
    },
    {
      "name": "Pune Work Commute Taxi Service",
      "description": "Our Pune Work Commute Taxi Service is designed to simplify your daily travel to and from work. With punctual pickups, clean vehicles, and attentive drivers, we make sure your office commute is efficient, comfortable, and safe every day."
    }
  ],
  "tableData": [
    ["Daily Office Cab Pune", "Pune Office Taxi Service"],
    ["Office Cab Booking Pune", "Daily Work Taxi Pune"],
    ["Corporate Daily Taxi Pune", "Affordable Office Cab Pune"],
    ["Office Taxi with Driver Pune", "Pune Office Cab Packages"],
    ["Pune Daily Commute Taxi", "Office Cab Service Near Me Pune"],
    ["Pune Daily Taxi Deals", "Pune Office Transport Cab"],
    ["Daily Office Cab Rental Pune", "Pune Office Shuttle Cab"],
    ["Pune Work Commute Taxi Service", "—"]
  ],


       "whychoose": [
    {
      "WhyChooseheading": "Reliable Daily Office Cab Service in Pune",
      "WhyChoosedescription": "Platinum24 Cabs provides punctual and dependable daily cab services for your office commute in Pune."
    },
    {
      "WhyChooseheading": "Comfortable and Air-Conditioned Vehicles",
      "WhyChoosedescription": "Travel to work in clean, sanitized, and well-maintained AC cabs ensuring comfort every day."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Local Route Knowledge",
      "WhyChoosedescription": "Our professional drivers know Pune’s traffic patterns and routes for timely drop-offs and pickups."
    },
    {
      "WhyChooseheading": "Flexible Booking and Subscription Plans",
      "WhyChoosedescription": "Choose from daily, weekly, or monthly packages tailored to your office commute schedule."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront and affordable pricing that includes fuel, tolls, and driver allowances."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Seamless Service",
      "WhyChoosedescription": "Our dedicated team is available round the clock to assist with bookings and any commute-related queries."
    },
    {
      "WhyChooseheading": "Safe and Trustworthy Ride for Professionals",
      "WhyChoosedescription": "Travel with verified drivers focused on your safety and convenience."
    },
    {
      "WhyChooseheading": "Ideal for Individuals and Corporate Clients",
      "WhyChoosedescription": "Whether you’re an individual commuter or a corporate team, our daily office cabs cater to all."
    }
  ]






















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer daily office cab services in Pune?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable daily office cab services in Pune to ensure timely and hassle-free commutes.',
    },
    {
        question: 'How can I book a daily office cab service in Pune with Platinum24 Cabs?',
        answer: 'You can book your daily office cab service through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for daily office cab service?',
        answer: 'We offer a range of vehicles including sedans, hatchbacks, and SUVs to accommodate individual and group office commutes.',
    },
    {
        question: 'Are the drivers experienced with Pune city routes?',
        answer: 'Yes, our drivers are professional and well-acquainted with Pune’s traffic patterns and office locations for timely drop-offs and pickups.',
    },
    {
        question: 'Can I schedule daily cab service for specific time slots?',
        answer: 'Absolutely! You can customize your pickup and drop-off times to match your office schedule.',
    },
    {
        question: 'Is the daily office cab service available on weekends?',
        answer: 'Yes, our service is available seven days a week, including weekends, based on your requirements.',
    },
    {
        question: 'Are the vehicles sanitized and safe for daily commutes?',
        answer: 'All our vehicles are regularly sanitized, and drivers follow strict safety protocols to ensure your health and safety.',
    },
    {
        question: 'Can I book daily office cab service for multiple employees?',
        answer: 'Yes, we offer corporate packages for daily office cabs to serve multiple employees with flexible billing options.',
    },
    {
        question: 'What payment options are available for daily office cab services?',
        answer: 'We accept cash, digital payments, and corporate invoicing to suit your convenience.',
    },
    {
        question: 'Is 24x7 booking available for daily office cab services in Pune?',
        answer: 'Yes, our booking service is available 24x7 to accommodate any scheduling changes or new bookings.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Anil Kulkarni',
        feedback: 'The daily office cab service by Platinum24 Cabs has made my commute smooth and stress-free. Highly recommended!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Patil',
        feedback: 'Reliable and punctual daily office cab service. The driver is courteous and the car is always clean.',
        rating: 5,
    },
];





























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const dailyOfficeCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable Daily Office Cab Service in Pune offering affordable and comfortable daily commute taxi solutions with professional drivers.",
  "areaServed": {
    "@type": "Place",
    "name": "Pune"
  },
  "serviceType": [
    "Daily Office Cab Pune",
    "Pune Office Taxi Service",
    "Office Cab Booking Pune",
    "Daily Work Taxi Pune",
    "Corporate Daily Taxi Pune",
    "Affordable Office Cab Pune",
    "Office Taxi with Driver Pune",
    "Pune Office Cab Packages",
    "Pune Daily Commute Taxi",
    "Office Cab Service Near Me Pune",
    "Pune Daily Taxi Deals",
    "Pune Office Transport Cab",
    "Daily Office Cab Rental Pune",
    "Pune Office Shuttle Cab",
    "Pune Work Commute Taxi Service"
  ],
  "telephone": "+91-XXXXXXXXXX"
};





    return (
        <div>
<Helmet>
  <title>Daily Office Cab Service in Pune | Affordable Office Taxi Pune</title>
  <meta
    name="description"
    content="Reliable Daily Office Cab Service in Pune offering affordable and comfortable daily commute taxi solutions with professional drivers."
  />
  <meta
    name="keywords"
    content="Daily Office Cab Pune, Pune Office Taxi Service, Office Cab Booking Pune, Daily Work Taxi Pune, Corporate Daily Taxi Pune, Affordable Office Cab Pune, Office Taxi with Driver Pune, Pune Office Cab Packages, Pune Daily Commute Taxi, Office Cab Service Near Me Pune, Pune Daily Taxi Deals, Pune Office Transport Cab, Daily Office Cab Rental Pune, Pune Office Shuttle Cab, Pune Work Commute Taxi Service"
  />
  <script type="application/ld+json">
    {JSON.stringify(dailyOfficeCabSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/71.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Dailyofficecabserviceinpune;